import { render, staticRenderFns } from "./DownloadSection.vue?vue&type=template&id=36bff7b9&lang=html&"
import script from "./DownloadSection.vue?vue&type=script&lang=js&"
export * from "./DownloadSection.vue?vue&type=script&lang=js&"
import style0 from "./DownloadSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports